import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveMessengerContainer } from "../../components/ActiveMessengerContainer/ActiveMessengerContainer";

const ActiveWhatsappScreen = () => {
  return (
    <ScreenLayout>
      <ActiveMessengerContainer messenger={"whatsapp"} />
    </ScreenLayout>
  );
};

export default ActiveWhatsappScreen;
